import { render, staticRenderFns } from "./qs3-05.vue?vue&type=template&id=51ba8a64&scoped=true&"
import script from "./qs3-05.vue?vue&type=script&lang=js&"
export * from "./qs3-05.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ba8a64",
  null
  
)

export default component.exports